import { render, staticRenderFns } from "./HtmlRenderFieldsForm.vue?vue&type=template&id=13f54745&scoped=true&"
import script from "./HtmlRenderFieldsForm.ts?vue&type=script&lang=ts&"
export * from "./HtmlRenderFieldsForm.ts?vue&type=script&lang=ts&"
import style0 from "./HtmlRenderFieldsForm.scss?vue&type=style&index=0&id=13f54745&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f54745",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
